// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-box[data-v-b5073624]{display:inline-block !important;margin:0 10px}`, "",{"version":3,"sources":["webpack://./components/admin/sections/FileSupport.vue"],"names":[],"mappings":"AACA,8BACE,+BAAA,CACA,aAAA","sourcesContent":["\n.preview-box {\n  display: inline-block !important;\n  margin: 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
